import { Component, computed, input, output } from '@angular/core';
import { UiButtonComponent, UiNumberComponent, UIIconComponent, UiDividerComponent } from '@design-system';
import { NumberToPersianWordsPipe } from '@tools';
import { OrderSide } from '@shared-types';
import { OrderConfirmSummary } from './order-confirm.model';

@Component({
	selector: 'app-order-confirm',
	imports: [UiButtonComponent, UiNumberComponent, NumberToPersianWordsPipe, UIIconComponent, UiDividerComponent],
	templateUrl: './order-confirm.component.html',
	host: {
		class: 'flex w-full flex-col pb-4',
		'data-cy': 'order-confirm'
	}
})
export class OrderConfirmComponent {
	readonly summary = input.required<OrderConfirmSummary>();
	readonly confirmLabel = input('تایید');
	readonly loading = input(false);

	readonly confirmed = output<void>();
	readonly cancelled = output<void>();

	OrderSide = OrderSide;

	readonly isOrderSplitting = computed(() => {
		const maxVolume = this.summary().maxVolume;
		const quantity = this.summary().quantity;
		return maxVolume !== undefined && maxVolume > 0 && quantity !== null && quantity > maxVolume;
	});

	readonly orderSplittedCount = computed(() => {
		const maxVolume = this.summary().maxVolume;
		if (!this.isOrderSplitting() || maxVolume === undefined || maxVolume <= 0) {
			return 0;
		}
		const quantity = this.summary().quantity;
		return Math.ceil(quantity / maxVolume);
	});

	readonly titlePrefix = computed(() => {
		if (this.isOrderSplitting() && !this.summary().orderConfirmationEnabled) {
			return 'تقسیم سفارش';
		}
		return this.summary().isEdit ? 'ویرایش درخواست' : 'ثبت درخواست';
	});
}
